import BaseProxy from './Proxy';

export default class SubstoreSubscriptionBookProxy extends BaseProxy {
  constructor(parameters = {}) {
    super('api/substore/subscriptionBook', parameters);
  }
}
